import AllCompaniesTable from './AllCompaniesTable';

export default AllCompaniesTable;
